import TYPES from '../../action-types';

/**
 * Change flag on assets immediately
 * @param {string[]} ids
 * @param {string} value
 */
const changedFlag = (ids, value, userId) => (dispatch) => {
  dispatch({
    type: TYPES.ASSETS.CHANGE_FLAG.COMPLETE,
    payload: {
      ids,
      keys: ['flag'],
      values: [value],
      eventType: 'flag',
      userId,
    },
  });
};

export default changedFlag;
